import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es7.array.includes.js";
import Vue from 'vue';
import DarkMixin from "../../mixins/dark.js";
import TagMixin from "../../mixins/tag.js";
import ListenersMixin from "../../mixins/listeners.js";
import { slot } from "../../utils/slot.js";
export var skeletonTypes = ['text', 'rect', 'circle', 'QBtn', 'QBadge', 'QChip', 'QToolbar', 'QCheckbox', 'QRadio', 'QToggle', 'QSlider', 'QRange', 'QInput', 'QAvatar'];
export var skeletonAnimations = ['wave', 'pulse', 'pulse-x', 'pulse-y', 'fade', 'blink', 'none'];
export default Vue.extend({
  name: 'QSkeleton',
  mixins: [DarkMixin, TagMixin, ListenersMixin],
  props: {
    type: {
      type: String,
      validator: function validator(v) {
        return skeletonTypes.includes(v);
      },
      default: 'rect'
    },
    animation: {
      type: String,
      validator: function validator(v) {
        return skeletonAnimations.includes(v);
      },
      default: 'wave'
    },
    square: Boolean,
    bordered: Boolean,
    size: String,
    width: String,
    height: String
  },
  computed: {
    style: function style() {
      return this.size !== void 0 ? {
        width: this.size,
        height: this.size
      } : {
        width: this.width,
        height: this.height
      };
    },
    classes: function classes() {
      return "q-skeleton--".concat(this.isDark === true ? 'dark' : 'light', " q-skeleton--type-").concat(this.type) + (this.animation !== 'none' ? " q-skeleton--anim q-skeleton--anim-".concat(this.animation) : '') + (this.square === true ? ' q-skeleton--square' : '') + (this.bordered === true ? ' q-skeleton--bordered' : '');
    }
  },
  render: function render(h) {
    return h(this.tag, {
      staticClass: 'q-skeleton',
      class: this.classes,
      style: this.style,
      on: _objectSpread({}, this.qListeners)
    }, slot(this, 'default'));
  }
});